module.exports = __webpack_public_path__ + "img/ea_bg2.0ed31e5d.jpg";